export default __webpack_public_path__ + "static/media/5.a270c3d5.png";